import { post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";

const emailsUrl = "/api/v1/email";
export function submitContactUsForm(
    parameter: SubmitContactUsFormApiParameter,
    companyName: string,
    country: string,
    address1: string,
    address2: string,
    address3: string,
    address4: string,
    cityName: string,
    postalCode: string,
) {
    const encodedCompanyName = encodeURIComponent(companyName);
    const encodedCountry = encodeURIComponent(country);
    const encodedCountryAddress1 = encodeURIComponent(address1 ?? "");
    const encodedCountryAddress2 = encodeURIComponent(address2 ?? "");
    const encodedCountryAddress3 = encodeURIComponent(address3 ?? "");
    const encodedCountryAddress4 = encodeURIComponent(address4 ?? "");
    const encodedCityName = encodeURIComponent(cityName ?? "");
    const encodedPostalCode = encodeURIComponent(postalCode ?? "");

    return post<SubmitContactUsFormApiParameter, void>(
        `${emailsUrl}/contactUs?companyName=${encodedCompanyName}&country=${encodedCountry}&address1=${encodedCountryAddress1}&address2=${encodedCountryAddress2}&address3=${encodedCountryAddress3}&address4=${encodedCountryAddress4}&cityName=${encodedCityName}&postalCode=${encodedPostalCode}`,
        parameter,
    );
}

const requestQuoteApi = "/api/v1/requestquote";
export function requestQuote(wishListId: string) {
    const encodedWishListId = encodeURIComponent(wishListId);

    return post<void>(`${requestQuoteApi}/${encodedWishListId}`);
}
